import { actions, selectors } from '@cinch/oxd-redux/compare/src'
import { CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import Component from './compare-button.component'

const { isBeingCompared, canCompare } = selectors
const { addVehicle, removeVehicle } = actions

export const mapStateToProps = (state: any, props: any) => {
  const isActive = isBeingCompared(state)(props.data.id)

  return {
    isActive,
    disabled: !isActive && !canCompare(state),
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onRemoveCompare: (id: number | string) => dispatch(removeVehicle(id, 'card')),
  onAddCompare: (data: CompareVehicle) => dispatch(addVehicle(data, 'card')),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
